<template>
  <div>
    <div class="container">
      <form autocomplete="off" novalidate @submit.prevent="submitInputsProfile">
        <HeadingOne class="-margin-md">お客さま情報のご入力</HeadingOne>

        <ErrorsAlert
          :errors="errors"
          :column-only="true"
          :items="inputItemsEn"
        ></ErrorsAlert>

        <WizardGroup>
          <MainWizard :active-index="0" type="entry"></MainWizard>
          <SubWizard :active-index="0" type="usernew"></SubWizard>
        </WizardGroup>

        <TableGroup>
          <HeadingTwo>お客さま情報</HeadingTwo>

          <div class="_mb-10">
            <small class="note important"
              >※氏名（漢字、フリガナ）などに誤りが無いか、必ずご確認ください。</small
            >
            <small class="note">※必須の項目は必ずご入力ください。</small>
          </div>

          <TableBox class="-entry">
            <TableBody>
              <TableRow>
                <template v-if="showNameKanjiLabel">
                  <TableHeader badge="必須" badge-size="-sm">
                    氏名<small>（漢字）</small>
                  </TableHeader>
                  <TableData :has-error="errors['name_kanji']">
                    <template v-if="userData.name_kanji">
                      <label>{{ userData.name_kanji }}</label>
                    </template>
                  </TableData>
                </template>
                <template v-else>
                  <TableHeader badge="必須" badge-size="-sm">
                    氏名<small
                      >（漢字）<small class="moji">【全角】</small></small
                    >
                  </TableHeader>
                  <TableData :has-error="errors['name_kanji']">
                    <InputgroupAppend class="name-box _mb-15">
                      <InputGroup
                        class="name"
                        :errors="errors"
                        :prop-names="['name_kanji']"
                      >
                        <div class="input-box _pr-sm-10 _mr-md-40">
                          <InputItem
                            id="lastname_kanji"
                            v-model="userData.lastname_kanji"
                            class="-sm"
                            :maxlength="13"
                            tracking-name="en002_lastname_kanji"
                          ></InputItem>
                          <InputLabel> 例：英雄 </InputLabel>
                        </div>
                        <div class="input-box _pl-sm-10">
                          <InputItem
                            id="firstname_kanji"
                            v-model="userData.firstname_kanji"
                            class="-sm"
                            :maxlength="13"
                            tracking-name="en002_firstname_kanji"
                          ></InputItem>
                          <InputLabel> 例：太郎 </InputLabel>
                        </div>
                      </InputGroup>
                    </InputgroupAppend>
                    <small class="warning"
                      >※左の欄に姓、右の欄に名が入るように訂正をお願い致します。</small
                    >
                  </TableData>
                </template>
              </TableRow>
              <TableRow>
                <template v-if="showNameKanaLabel">
                  <TableHeader badge="必須" badge-size="-sm">
                    氏名<small>（フリガナ）</small>
                  </TableHeader>
                  <TableData :has-error="errors['name_kana']">
                    <template v-if="userData.name_kana">
                      <label>{{ userData.name_kana }}</label>
                    </template>
                  </TableData>
                </template>
                <template v-else>
                  <TableHeader badge="必須" badge-size="-sm">
                    氏名<small
                      >（フリガナ）<small class="moji"
                        >【全角カナ】</small
                      ></small
                    >
                  </TableHeader>
                  <TableData :has-error="errors['name_kana']">
                    <InputgroupAppend class="name-box _mb-15">
                      <InputGroup
                        class="name _mr-md-40"
                        :errors="errors"
                        :prop-names="['name_kana']"
                      >
                        <div class="input-box _pr-sm-10 _mr-md-40">
                          <InputItem
                            id="lastname_kana"
                            v-model="userData.lastname_kana"
                            class="-sm"
                            :maxlength="17"
                            tracking-name="en002_lastname_kana"
                          ></InputItem>
                          <InputLabel> 例：エイユウ </InputLabel>
                        </div>
                        <div class="input-box _pl-sm-10">
                          <InputItem
                            id="firstname_kana"
                            v-model="userData.firstname_kana"
                            class="-sm"
                            :maxlength="17"
                            tracking-name="en002_firstname_kana"
                          ></InputItem>
                          <InputLabel> 例：タロウ </InputLabel>
                        </div>
                      </InputGroup>
                    </InputgroupAppend>
                    <small class="warning"
                      >※左の欄に姓、右の欄に名が入るように訂正をお願い致します。</small
                    >
                  </TableData>
                </template>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm">
                  生年月日<small v-if="!hasBth" class="moji"
                    >【半角数字】</small
                  >
                </TableHeader>
                <TableData :has-error="errors['bth']">
                  <template v-if="hasBth">
                    <label>{{ displayBth(userData.bth) }}</label>
                  </template>
                  <template v-else>
                    <InputGroup :errors="errors" :prop-names="['bth']">
                      <InputItem
                        id="bth"
                        v-model="userData.bth"
                        class="-sm"
                        type="text"
                        :maxlength="8"
                        tracking-name="en002_bth"
                      ></InputItem>
                      <InputLabel> 入力例：1988年1月1日 → 19880101 </InputLabel>
                    </InputGroup>
                  </template>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"> 性別 </TableHeader>
                <TableData :has-error="errors['sex']">
                  <template v-if="hasSex">
                    {{ displaySex(userData.sex) }}
                  </template>
                  <template v-else>
                    <InputGroup :errors="errors" :prop-names="['sex']">
                      <BtngroupRadio>
                        <BtnRadio
                          v-for="(sexType, index) in sexTypes"
                          :id="'sexType' + index"
                          :key="'sexType' + index"
                          v-model="userData.sex"
                          name="sexTypeRadio"
                          :value="sexType['value']"
                          :label="sexType['name']"
                          :tracking-name="`en002_sex_type_${index}`"
                        >
                        </BtnRadio>
                      </BtngroupRadio>
                    </InputGroup>
                  </template>
                </TableData>
              </TableRow>
              <TableRow v-if="!!hasPhoneAu">
                <TableHeader badge="必須" badge-size="-sm">
                  au携帯電話番号または<br />UQ mobile 電話番号
                </TableHeader>
                <TableData :has-error="errors['phone_au_1']">
                  <InputGroup :errors="errors" :prop-names="['phone_au_1']">
                    <div id="phoneNumber1">
                      {{ userData.phone_au_1 }}-{{ userData.phone_au_2 }}-{{
                        userData.phone_au_3
                      }}
                    </div>
                  </InputGroup>
                </TableData>
              </TableRow>

              <TableRow v-else>
                <TableHeader badge="必須" badge-size="-sm"
                  >電話番号<small
                    >（その他）<small class="moji">【半角数字】</small></small
                  ></TableHeader
                >
                <TableData :has-error="errors['phone_mobile']">
                  <InputGroup :errors="errors" :prop-names="['phone_mobile']">
                    <InputgroupAppend>
                      <InputPhone
                        id="phone_mobile"
                        :phone="{
                          phone1: userData.phone_mobile_1,
                          phone2: userData.phone_mobile_2,
                          phone3: userData.phone_mobile_3,
                        }"
                        tracking-name="en002_phone_mobile"
                        @input="setPhone"
                      ></InputPhone>
                    </InputgroupAppend>
                    <InputLabel> 入力例： 090-****-**** </InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>

              <template
                v-if="
                  showDefaultMail(
                    userData.ez_mail,
                    userData.mail_1,
                    userData.mail_2
                  )
                "
              >
                <TableRow>
                  <TableHeader badge="必須" badge-size="-sm" rowspan="3">
                    メールアドレス
                    <BtnTooltip
                      target="mailAddressTooltip"
                      class="-question"
                    ></BtnTooltip>
                    <TooltipsItem
                      target="mailAddressTooltip"
                      placement="righttop"
                      clazz="question-box"
                    >
                      au
                      IDにご登録の連絡先メールアドレスを表示しております。変更をご希望の場合は、お申し込み完了後にau
                      IDサイトにて連絡先メールアドレスをご登録ください。
                    </TooltipsItem>
                  </TableHeader>
                  <TableData id="emailAddress1">
                    {{ displayEzMail(userData.ez_mail) }}
                  </TableData>
                </TableRow>
                <TableRow>
                  <TableData id="emailAddress2">
                    {{ displayMail1(userData.mail_1) }}
                  </TableData>
                </TableRow>
                <TableRow>
                  <TableData id="emailAddress3">
                    {{ displayMail2(userData.mail_2) }}
                  </TableData>
                </TableRow>
              </template>

              <template
                v-if="
                  showLoanMail(
                    userData.ez_mail,
                    userData.mail_1,
                    userData.mail_2
                  )
                "
              >
                <TableRow>
                  <TableHeader badge="必須" badge-size="-sm">
                    メールアドレス<small class="moji">【半角英数】</small>
                  </TableHeader>
                  <TableData :has-error="errors['loan_mail']">
                    <InputGroup :errors="errors" :prop-names="['loan_mail']">
                      <InputItem
                        id="loan_mail"
                        v-model="userData.loan_mail"
                        class="-lg"
                        :maxlength="50"
                        tracking-name="en002_loan_mail"
                      ></InputItem>
                      <InputLabel> 入力例：****@au.com </InputLabel>
                    </InputGroup>
                  </TableData>
                </TableRow>

                <TableRow>
                  <TableHeader badge="必須" badge-size="-sm">
                    メールアドレス<small
                      >（確認用再入力）<small class="moji"
                        >【半角英数】</small
                      ></small
                    >
                  </TableHeader>
                  <TableData :has-error="errors['loan_mail_confirmation']">
                    <InputGroup
                      :errors="errors"
                      :prop-names="['loan_mail_confirmation']"
                    >
                      <InputItem
                        id="loan_mail_confirmation"
                        v-model="userData.loan_mail_confirmation"
                        class="-lg"
                        :maxlength="50"
                        tracking-name="en002_loan_mail_confirmation"
                      ></InputItem>
                      <InputLabel> 入力例：****@au.com </InputLabel>
                    </InputGroup>
                  </TableData>
                </TableRow>
              </template>

              <TableRow>
                <TableHeader class="-hastooltip">
                  キャンペーンメール受信
                  <BtnTooltip
                    target="mailNoticeTooltip"
                    class="-question"
                  ></BtnTooltip>
                  <TooltipsItem target="mailNoticeTooltip" placement="righttop">
                    ご不要の場合はチェックを外してください。なお、大切なご案内に関するメールは、チェックを外した場合でも全てのお客さまに配信されます。
                  </TooltipsItem>
                </TableHeader>
                <TableData>
                  <InputGroup>
                    <InputCheck
                      id="notice_flg"
                      v-model="userData.notice_flg"
                      value="true"
                      tracking-name="en002_notice_flg"
                      >同意する</InputCheck
                    >
                  </InputGroup>
                </TableData>
              </TableRow>

              <TableRow>
                <TableHeader badge="必須" badge-size="-sm">
                  暗証番号<small class="moji">【半角数字4文字】</small>
                </TableHeader>
                <TableData :has-error="errors['pincode']">
                  <p class="pincode-txt">
                    暗証番号を<span class="important">4桁の数字</span
                    >で設定ください。今後のお手続き等にご利用いただきます。<br
                      class="-spnone"
                    />生年月日、電話番号、「0000」などの4桁の同じ数字はご利用いただけません。
                  </p>
                  <InputCheck
                    id="pincode_flg"
                    v-model="showPinCode"
                    value="true"
                    class="pincode-flg"
                    tracking-name="en002_pincode_flg"
                    >暗証番号を表示する</InputCheck
                  >
                  <InputGroup :errors="errors" :prop-names="['pincode']">
                    <InputItem
                      id="pincode"
                      v-model="userData.pincode"
                      class="-sm"
                      :type="pinCodeInputType"
                      :maxlength="4"
                      tracking-name="en002_pincode"
                    ></InputItem>
                    <InputLabel> </InputLabel>
                    <InputItem
                      id="pincode_confirmation"
                      v-model="userData.pincode_confirmation"
                      class="-sm pincode-confirmation"
                      :type="pinCodeInputType"
                      :maxlength="4"
                      tracking-name="en002_pincode_confirmation"
                    ></InputItem
                    ><small class="pincode-confirmation-note"
                      >（確認用再入力）</small
                    >
                    <InputLabel> </InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>

              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"
                  >運転免許証の有無</TableHeader
                >
                <TableData :has-error="errors['driver_license_flg']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['driver_license_flg']"
                  >
                    <BtngroupRadio>
                      <BtnRadio
                        v-for="(driverLicenseFlg, index) in driverLicenseFlgs"
                        :id="'driverLicenseFlg' + index"
                        :key="'driverLicenseFlg' + index"
                        v-model="userData.driver_license_flg"
                        name="driverLicenseFlgRadio"
                        :value="driverLicenseFlg['value']"
                        :label="driverLicenseFlg['name']"
                        :tracking-name="`en002_driver_license_flg_${index}`"
                      >
                      </BtnRadio>
                    </BtngroupRadio>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow v-show="userData.driver_license_flg === '1'">
                <TableHeader badge="必須" badge-size="-sm"
                  >運転免許証番号<small class="moji"
                    >【半角数字】</small
                  ></TableHeader
                >
                <TableData :has-error="errors['driver_license_num']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['driver_license_num']"
                  >
                    <InputgroupAppend>
                      <InputItem
                        id="driver_license_num"
                        v-model="userData.driver_license_num"
                        type="text"
                        class="-md"
                        :maxlength="12"
                        tracking-name="en002_driver_license_num"
                      ></InputItem>
                    </InputgroupAppend>
                    <InputLabel>入力例：000000000000</InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
            <!-- TableBody -->
          </TableBox>
          <!--ご自宅情報-->
          <HeadingTwo>ご自宅情報</HeadingTwo>
          <TableBox class="-entry">
            <TableBody>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm" colspan="2">
                  郵便番号<small class="moji">【半角数字※ハイフン不要】</small>
                </TableHeader>
                <TableData :has-error="errors['postcode']">
                  <InputGroup :errors="errors" :prop-names="['postcode']">
                    <InputgroupAppend>
                      <InputItem
                        id="postcode"
                        v-model="userData.postcode"
                        type="text"
                        class="-md"
                        :maxlength="7"
                        tracking-name="en002_postcode"
                      ></InputItem>
                    </InputgroupAppend>
                    <InputLabel>入力例：1234567</InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader class="-harfleft" rowspan="4">
                  ご住所<small>（漢字）</small>
                </TableHeader>
                <TableHeader class="-harfright" badge="必須" badge-size="-sm">
                  都道府県<small class="moji">【全角】</small>
                </TableHeader>
                <TableData :has-error="errors['address_region']">
                  <InputGroup :errors="errors" :prop-names="['address_region']">
                    <InputGroup>
                      <InputItem
                        id="address_region"
                        v-model="userData.address_region"
                        type="text"
                        class="-md"
                        :maxlength="60"
                        tracking-name="en002_address_region"
                      ></InputItem>
                      <InputLabel>入力例：東京都</InputLabel>
                    </InputGroup>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader class="-harfright" badge="必須" badge-size="-sm">
                  市区町村<small class="moji">【全角】</small>
                </TableHeader>
                <TableData :has-error="errors['address_city']">
                  <InputGroup :errors="errors" :prop-names="['address_city']">
                    <InputItem
                      id="address_city"
                      v-model="userData.address_city"
                      class="-lg"
                      :maxlength="60"
                      tracking-name="en002_address_city"
                    ></InputItem>
                    <InputLabel>入力例：港区</InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader class="-harfright" badge="必須" badge-size="-sm">
                  地名・番地以下<small class="moji">【全角】</small>
                </TableHeader>
                <TableData :has-error="errors['address_street']">
                  <InputGroup :errors="errors" :prop-names="['address_street']">
                    <small class="address-note important"
                      >※丁目、番地等は必ずご自身で記入して下さい。</small
                    >
                    <InputItem
                      id="address_street"
                      v-model="userData.address_street"
                      class="-lg"
                      :maxlength="60"
                      tracking-name="en002_address_street"
                    ></InputItem>
                    <InputLabel>入力例：○○○１－１－１</InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader class="-harfright"
                  >建物名・部屋番号<small class="moji"
                    >【全角】</small
                  ></TableHeader
                >
                <TableData :has-error="errors['address_building']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['address_building']"
                  >
                    <InputItem
                      id="address_building"
                      v-model="userData.address_building"
                      class="-lg"
                      :maxlength="60"
                      tracking-name="en002_address_building"
                    ></InputItem>
                    <InputLabel>入力例：○○マンション１０１号室</InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm" colspan="2">
                  ご住所<small
                    >（フリガナ）<small class="moji"
                      >【全角カナ・全角英数】</small
                    ></small
                  >
                </TableHeader>
                <TableData :has-error="errors['address_kana']">
                  <InputGroup :errors="errors" :prop-names="['address_kana']">
                    <TextArea
                      id="address_kana1"
                      v-model="userData.address_kana"
                      class="furigana"
                      :maxlength="166"
                      exclude-line-code="true"
                      tracking-name="en002_address_kana"
                    ></TextArea>
                    <InputLabel
                      >入力例：トウキョウトミナトク○○○１－１－１○○マンション１０１ゴウシツ<br />※スペースを空けず、つめてご入力ください。</InputLabel
                    >
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
            <!-- TableBody -->
          </TableBox>

          <TableBox class="-entry">
            <TableBody>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"
                  >お住まいの種類</TableHeader
                >
                <TableData :has-error="errors['home_type']">
                  <InputGroup :errors="errors" :prop-names="['home_type']">
                    <BtngroupRadio>
                      <BtnRadio
                        v-for="(homeType, index) in home_types"
                        :id="'homeType' + index"
                        :key="'homeType' + index"
                        v-model="userData.home_type"
                        name="homeTypeRadio"
                        :value="homeType['value']"
                        :label="homeType['name']"
                        :class="{ '-xs': homeType['value'] === '5' }"
                        :tracking-name="`en002_home_type_${index}`"
                      >
                      </BtnRadio>
                    </BtngroupRadio>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"
                  >居住年数</TableHeader
                >
                <TableData :has-error="errors['kyjy_ngt']">
                  <InputGroup :errors="errors" :prop-names="['kyjy_ngt']">
                    <BtngroupRadio>
                      <BtnRadio
                        v-for="(residenceYear, index) in residence_years"
                        :id="'residenceYear' + index"
                        :key="'residenceYear' + index"
                        v-model="userData.nky_ngt"
                        name="residenceYearRadio"
                        :value="residenceYear['value']"
                        :label="residenceYear['name']"
                        :tracking-name="`en002_residence_year_${index}`"
                      >
                      </BtnRadio>
                    </BtngroupRadio>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm" class="-hastooltip"
                  >住宅ローンもしくは家賃のお支払い<small
                    >(月額)<small class="moji">【半角数字】</small></small
                  >
                  <BtnTooltip
                    target="housingLoanTooltip"
                    class="-question"
                  ></BtnTooltip>
                  <TooltipsItem
                    target="housingLoanTooltip"
                    placement="righttop"
                  >
                    ご自身のご負担がない場合は「0」を入力してください。
                  </TooltipsItem>
                </TableHeader>
                <TableData :has-error="errors['rent_loan_amount']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['rent_loan_amount']"
                  >
                    <InputgroupAppend>
                      <InputItem
                        id="rentLoanAmount"
                        v-model="userData.rent_loan_amount"
                        type="text"
                        class="-sm"
                        :maxlength="10"
                        tracking-name="en002_rent_loan_amount"
                      ></InputItem>
                      <InputAppend>円／月</InputAppend>
                    </InputgroupAppend>
                    <InputLabel>入力例：75000</InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>
          <TableBox class="-entry">
            <TableBody>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"
                  >ご家族<small>（配偶者さま）</small></TableHeader
                >
                <TableData :has-error="errors['marriage_status']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['marriage_status']"
                  >
                    <BtngroupRadio>
                      <BtnRadio
                        v-for="(marriageStatus, index) in marriage_statuses"
                        :id="'marriageStatus' + index"
                        :key="'marriageStatus' + index"
                        v-model="userData.marriage_status"
                        name="marriageStatus"
                        :value="marriageStatus['value']"
                        :label="marriageStatus['name']"
                        :tracking-name="`en002_marriage_status_${index}`"
                      >
                      </BtnRadio>
                    </BtngroupRadio>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"
                  >ご家族<small>（お子さま）</small>
                  <BtnTooltip
                    target="numberOfChildrenTooltip"
                    class="-question"
                  ></BtnTooltip>
                  <TooltipsItem
                    target="numberOfChildrenTooltip"
                    placement="righttop"
                  >
                    生計を同一とするお子さまの人数をご入力ください。
                  </TooltipsItem>
                </TableHeader>
                <TableData :has-error="errors['number_of_children']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['number_of_children']"
                  >
                    <BtngroupRadio>
                      <BtnRadio
                        v-for="(numberOfChildren, index) in number_of_children"
                        :id="'numberOfChildren' + index"
                        :key="'numberOfChildren' + index"
                        v-model="userData.number_of_children"
                        name="numberOfChildren"
                        :value="numberOfChildren['value']"
                        :label="numberOfChildren['name']"
                        :tracking-name="`en002_number_of_children_${index}`"
                      >
                      </BtnRadio>
                    </BtngroupRadio>
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
            <!-- TableBody -->
          </TableBox>
        </TableGroup>

        <BtngroupDouble class="-margin-lg">
          <template #main>
            <BtnMain class="-main" @click.prevent="submitInputsProfile">
              お勤め先のご入力へ
            </BtnMain>
          </template>
          <template #back>
            <BtnBack class="-back -sm" router-name="en001"> 戻る </BtnBack>
          </template>
        </BtngroupDouble>
      </form>
    </div>
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import { initCredentials } from "@/utils/Auth";
import { goToErrorPage, scrollTop } from "@/utils/Other";

import {
  setHasSex,
  displaySex,
  setHasBth,
  displayBth,
  setHasPhoneAu,
  displayEzMail,
  displayMail1,
  displayMail2,
  showLoanMail,
  showDefaultMail,
  setPhoneMobile,
} from "@/utils/UserData";

import {
  validateProfileLambdaInvoke,
  getUserDataLambdaInvoke,
  registDeviceInfoDataLambdaInvoke,
} from "@/utils/LambdaHelper";
import {
  setTrackingEventDataSetting,
  getDeviceInfoData,
} from "@/utils/TrackingDataHelper";
import {
  sexTypes,
  driverLicenseFlgs,
  homeTypes,
  residenceYears,
  marriageStatuses,
  numberOfChildren,
  inputItemsEn,
} from "@/constants/constant";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import SubWizard from "@/components/wizard/SubWizard";
import TableGroup from "@/components/tables/TableGroup";
import HeadingTwo from "@/components/heading/HeadingTwo";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtngroupRadio from "@/components/button/BtngroupRadio";
import BtnRadio from "@/components/button/BtnRadio";
import BtnTooltip from "@/components/button/BtnTooltip";
import TooltipsItem from "@/components/tooltip/TooltipsItem";
import InputPhone from "@/components/input/InputPhone";
import InputGroup from "@/components/input/InputGroup";
import InputItem from "@/components/input/InputItem";
import InputLabel from "@/components/input/InputLabel";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import InputAppend from "@/components/input/InputAppend";
// import BtnInput from "@/components/button/BtnInput";
// import BtnSelect from "@/components/button/BtnSelect";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import InputCheck from "@/components/input/InputCheck";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import TextArea from "@/components/input/TextArea";

export default {
  name: "En002",
  components: {
    TextArea,
    ErrorsAlert,
    InputCheck,
    BtnBack,
    BtnMain,
    BtngroupDouble,
    // BtnSelect,
    // BtnInput,
    InputAppend,
    InputgroupAppend,
    InputLabel,
    InputItem,
    InputGroup,
    InputPhone,
    TooltipsItem,
    BtnTooltip,
    BtnRadio,
    BtngroupRadio,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    HeadingTwo,
    TableGroup,
    SubWizard,
    MainWizard,
    WizardGroup,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "お客さま情報のご入力",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,お客さま情報",
    });

    return {
      setHasSex,
      displaySex,
      setHasBth,
      displayBth,
      setHasPhoneAu,
      displayEzMail,
      displayMail1,
      displayMail2,
      showLoanMail,
      showDefaultMail,
    };
  },
  data() {
    return {
      errors: {},
      sexTypes: sexTypes,
      driverLicenseFlgs: driverLicenseFlgs,
      home_types: homeTypes,
      residence_years: residenceYears,
      marriage_statuses: marriageStatuses,
      number_of_children: numberOfChildren,
      showPinCode: "true",
      userData: {
        name_kanji: "",
        name_kana: "",
        lastname_kana: "",
        lastname_kanji: "",
        firstname_kana: "",
        firstname_kanji: "",
        eva_kjn: "", //    漢字名
        eva_kjs: "", //    漢字姓
        eva_knn: "", //    カナ名
        eva_kns: "", //    カナ姓
        eva_birth: "",
        eva_sbt: "",
        bth: "",
        sex: "",
        phone_au_1: "",
        phone_au_2: "",
        phone_au_3: "",
        phone_mobile_1: "",
        phone_mobile_2: "",
        phone_mobile_3: "",
        ez_mail: "",
        mail_1: "",
        mail_2: "",
        loan_mail: "",
        loan_mail_confirmation: "",
        notice_flg: "",
        pincode: "",
        pincode_confirmation: "",
        driver_license_flg: "00",
        driver_license_num: "",
        postcode: "",
        address_region: "",
        address_city: "",
        address_street: "",
        address_building: "",
        address_kana: "",
        home_type: "00",
        nky_ngt: "",
        rent_loan_amount: "",
        marriage_status: "00",
        number_of_children: "00",
        eva_kddi_umu_kbn: "",
        eva_uq_admission_kbn: "",
      },
      hasPhoneAu: false,
      nkyNgtYyyy: "",
      nkyNgtMm: "",
      isDisabled: false,
      noticeFlg: "",
      hasSex: false,
      hasBth: false,
      inputItemsEn: inputItemsEn,
      trackingEventDataSetting: {},
    };
  },
  computed: {
    pinCodeInputType() {
      return this.showPinCode ? "text" : "password";
    },
    showNameKanjiLabel() {
      if (
        this.userData.eva_kjn.length === 0 ||
        this.userData.eva_kjn.length > 13
      ) {
        return false;
      }
      if (
        this.userData.eva_kjs.length === 0 ||
        this.userData.eva_kjs.length > 13
      ) {
        return false;
      }
      if (this.userData.eva_kjn.length + this.userData.eva_kjs.length > 14) {
        return false;
      }
      if (
        this.userData.eva_kddi_umu_kbn === "0" &&
        this.userData.eva_uq_admission_kbn === "0"
      ) {
        return false;
      }
      if (
        this.userData.eva_kddi_umu_kbn === "0" &&
        this.userData.eva_uq_admission_kbn === "1"
      ) {
        return false;
      }
      return true;
    },
    showNameKanaLabel() {
      if (
        this.userData.eva_knn.length === 0 ||
        this.userData.eva_knn.length > 17
      ) {
        return false;
      }
      if (
        this.userData.eva_kns.length === 0 ||
        this.userData.eva_kns.length > 17
      ) {
        return false;
      }
      if (this.userData.eva_knn.length + this.userData.eva_kns.length > 18) {
        return false;
      }
      if (
        this.userData.eva_kddi_umu_kbn === "0" &&
        this.userData.eva_uq_admission_kbn === "0"
      ) {
        return false;
      }
      if (
        this.userData.eva_kddi_umu_kbn === "0" &&
        this.userData.eva_uq_admission_kbn === "1"
      ) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key].toString().trim();
            }
          }
          this.hasSex = setHasSex(this.userData.eva_sbt);
          this.hasBth = setHasBth(this.userData.eva_birth);

          this.hasPhoneAu = setHasPhoneAu(
            this.userData.phone_au_1,
            this.userData.phone_au_2,
            this.userData.phone_au_3
          );

          // 使用していません
          //  setHasPhoneMobile(
          //       this.userData.phone_mobile_1,
          //       this.userData.phone_mobile_2,
          //       this.userData.phone_mobile_3
          //     );

          this.initNoticeFlg(res);
          this.setPostParam();
          this.$store.dispatch("setSystemAuId", res.system_auid);
          this.registDeviceInfoData();
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
    setTrackingEventDataSetting();
  },
  methods: {
    setPhone(data) {
      this.userData = {
        ...this.userData,
        ...setPhoneMobile(data.phone1, data.phone2, data.phone3),
      };
    },
    submitInputsProfile() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        this.setUserDataNoticeFlg();
        let orgDriverLicenseNum = this.userData.driver_license_num;
        if (this.userData.driver_license_flg === "0") {
          this.userData.driver_license_num = "";
        }
        initCredentials()
          .then(() => {
            validateProfileLambdaInvoke(this.userData)
              .then((res) => {
                if (res.redirect_page) {
                  // 未成年の場合入会拒否へ遷移する
                  let pageId = res.redirect_page.replace("-", "").toLowerCase();
                  this.$router.push({ name: pageId });
                } else {
                  this.errors = res.errors || {};
                  if (Object.keys(this.errors).length > 0) {
                    this.userData.driver_license_num = orgDriverLicenseNum;
                    scrollTop();
                    this.isDisabled = false;
                  } else {
                    this.$router.push({ name: "en003" });
                  }
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    setUserDataNoticeFlg() {
      if (this.userData.notice_flg === null) {
        this.userData.notice_flg = "";
      }
    },
    initNoticeFlg(res) {
      if (!("notice_flg" in res)) {
        this.userData.notice_flg = "true";
      }
    },
    setPostParam() {
      if (
        showLoanMail(
          this.userData.ez_mail,
          this.userData.mail_1,
          this.userData.mail_2
        )
      ) {
        delete this.userData["ez_mail"];
        delete this.userData["mail_1"];
        delete this.userData["mail_2"];
      } else {
        delete this.userData["loan_mail"];
        delete this.userData["loan_mail_confirmation"];
      }
      if (this.hasPhoneAu) {
        delete this.userData["phone_mobile_1"];
        delete this.userData["phone_mobile_2"];
        delete this.userData["phone_mobile_3"];
      } else {
        delete this.userData["phone_au_1"];
        delete this.userData["phone_au_2"];
        delete this.userData["phone_au_3"];
      }
    },
    async registDeviceInfoData() {
      try {
        if (this.$store.getters.getSystemAuId) {
          let deviceInfoData = await getDeviceInfoData();
          registDeviceInfoDataLambdaInvoke(deviceInfoData)
            .then(() => {})
            .catch(() => {});
        }
      } catch (e) {
        // console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.furigana {
  font-family: inherit;
  @include mq-down() {
    height: 100px;
  }
  @include mq-up() {
    height: 60px;
  }
}

.wizard-list {
  background-color: red;
}

.flex {
  @include flex(flex, space-between, center, row, nowrap);
}

.list:first-child {
  @include mq-down(md) {
    width: 80%;
  }
}
.list:last-child {
  margin-right: 0;
  @include mq-down(md) {
    width: 90%;
  }
}

.table-row {
  &.-border {
    border-bottom: 1px solid #cccccc;
  }
}
.table-data {
  vertical-align: middle;
  > .inputgroup-append {
    &.name-box {
      align-items: flex-end;
      .input-group {
        &.name {
          display: flex;
          flex-wrap: wrap;
          .input-box {
            @include mq-down(md) {
              max-width: 50%;
              width: 100%;
            }
          }
        }
      }
    }
  }
  &.name-box {
    @include flex(flex, flex-start, center, row, wrap);
    width: 100%;
    border: none;
    @include mq-down(md) {
      align-items: flex-start;
      justify-content: space-between;
    }
    .warning {
      width: 100%;
    }
    .input-group {
      @include mq-down() {
        width: 50%;
        &:first-child {
          padding-right: 10px;
        }
      }
      &.name {
        @include mq-down(md) {
          margin-bottom: 15px;
        }
        @include mq-up(md) {
          /*max-width: 30%;*/
          /*width: 100%;*/
        }
      }
      .input-item {
        @include mq-down(md) {
          max-width: 130px;
          width: 100%;
        }
      }
      .input-append {
        min-width: 48px;
      }
    }
  }
}

.note {
  display: block;
  text-indent: -0.5em;
  margin-left: 0.5em;
  margin-bottom: 2px;
}

.important {
  color: $danger;
}

.pincode-txt {
  margin-bottom: 18px;
  @include mq-down(md) {
    line-height: 18px;
  }
  @include mq-up(md) {
    line-height: 24px;
  }
}

.pincode-flg {
  display: block;
  margin-bottom: 20px;
  line-height: 1;
}

.pincode-confirmation {
  @include mq-down(md) {
    margin-top: 5px;
  }
  @include mq-up(md) {
    margin-top: 15px;
  }
}

.pincode-confirmation-note {
  display: inline-block;
  margin-left: 6px;
}

.address-note {
  display: inline-block;
  @include mq-down(md) {
    margin-bottom: 6px;
  }
  @include mq-up(md) {
    margin-bottom: 15px;
  }
}
</style>
